import { cilTrash, cilXCircle } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CButton, CImg } from '@coreui/react';
import * as React from 'react';

interface IProps {
	src: string;
	onRemove?: () => void;
}

interface IState {
	isFullscreen: boolean;
}

// Représente une miniature 
//
export class KThumbnail extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			isFullscreen: false
		}
	}

	//#region Local Events

	toggle = () => { this.setState({ isFullscreen: !this.state.isFullscreen }) }

	removeThumb = () => { if (this.props.onRemove) this.props.onRemove(); }

	//#endregion 

	//#region Rendus

	renderImage = () => {
		if (!this.state.isFullscreen) {
			return <img src={this.props.src} onClick={this.toggle} />
		}

		return (
			<div className="FullScreenWrapper">
				<CImg onClick={this.toggle} src={this.props.src} />
				<div className="controls">
					<CButton size="lg" color="primary" onClick={() => { this.toggle(); }}><CIcon content={cilXCircle} /></CButton >
					<CButton size="lg" color="danger" onClick={this.removeThumb}><CIcon content={cilTrash} /></CButton >
				</div>
			</div>)
	}

	render = () =>

		<div className="KThumbnail">
			{this.renderImage()}
		</div>

	//#endregion 
} 
